export interface KeycloakUser {
  active: boolean;
  cellphone: string;
  groupId: string;
  email: string;
  firstName: string;
  fullName: string;
  id: string;
  locale: string;
  lastName: string;
  roles: string[];
  username: string;
}

export type RolesCondition = 'and' | 'or' | undefined;

export interface ParsedKeycloakToken {
  id: string;
  contractorScope: string;
  email: string;

  family_name: string;

  given_name: string;
  locale: string;
  name: string;

  preferred_username: string;

  realm_access: {
    roles: string[] | undefined;
  };
  sub: string;
  userScope: string;
  userCategory: string;
  authFlow: string;
  federatedUser: boolean;
}

export interface LoggedInUser {
  id: string;
  email: string;
  locale: string;
  name: string;
  selfserviceAdmin: boolean;
  selfserviceGroupAdmin: boolean;
  customerServiceAgent: boolean;
  roles: string[];
  group: GroupUserData | undefined;
}

export interface GroupUserData {
  id: string;
  name: string;
}

export enum SelfserviceHubRoles {
  SelfserviceGroupAdmin = 'SelfserviceGroupAdmin',
  SelfserviceAdmin = 'SelfserviceAdmin',
  SelfserviceUser = 'SelfserviceUser',
  CustomerServiceAgent = 'CustomerServiceAgent',
  B2CSalesAgent = 'B2CSalesAgent',
}

export enum SelfserviceGroupAdminRoles {
  SelfserviceGroupAdmin = 'SelfserviceGroupAdmin',
  SelfserviceAdmin = 'SelfserviceAdmin',
}

export enum CustomerServiceAgentRoles {
  CustomerServiceAgent = 'CustomerServiceAgent',
}
